module.exports = __webpack_public_path__ + "assets/718dded3393324e992b225ac61329e0c.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-latin-ext-400-normal.woff2
// module id = 2639
// module chunks = 121